// extracted by mini-css-extract-plugin
export default {"worldsArea":"WorldsArea_worldsArea__sLnw+","worldsCarousel":"WorldsArea_worldsCarousel__+6w7I","worldsList":"WorldsArea_worldsList__5JZzn"};